<template>
  <section class="terms-and-privacy">
    <a-breadcrumbs />
    <h1 class="terms-and-privacy__title">{{ Title }}</h1>
    <a-render-html
      :html="processHtml(Content)"
      class="terms-and-privacy__content html-content__font-styles"
    />
  </section>
</template>

<script>
import ABreadcrumbs from 'shared/ABreadcrumbs'
import mixins from '@/utils/mixins'
import { PAGE_SCHEME_TYPE } from 'enums/pageSchemes'
import { ROUTE } from 'enums/routes'
import { getParsedHtmlWithReplacedMediaAttrs } from '@/utils/helpers/mediaProperties'
import { processHtml } from '@/utils/helpers/processHtml'
import ARenderHtml from 'shared/ARenderHtml'
import {
  generateCanonicalUrlForStaticPage,
  checkIfNonCanonicalPath
} from '@/utils/helpers/canonical-links'
import { redirectHandler } from '@/utils/helpers/redirects/helpers'

const MODEL = {
  Title: 'Privacy Notice',
  Content: '',
  ContentImages: [],
  ContentVideos: []
}

export default {
  name: 'PrivacyNotice',
  mixins: [mixins.initialScroll, mixins.setPageLoaded],
  components: { ARenderHtml, ABreadcrumbs },
  head() {
    const name = 'Privacy Notice'
    const headline = this.Title
    const text = this.$helper.htmlToText(this.Content)
    const link = this.$helper.getFullPath(this)

    const webPageSchemeData = {
      relatedLink: link,
      significantLink: link,
      alternativeHeadline: name,
      headline,
      keywords: name,
      text,
      description: name,
      mainEntityOfPage: name,
      name: headline
    }

    return this.$generateMetaTags({
      titleParam: name,
      descriptionParam: name,
      schemes: [
        { type: PAGE_SCHEME_TYPE.ORGANIZATION },
        { type: PAGE_SCHEME_TYPE.WEB_PAGE, data: webPageSchemeData },
        ...this.$helper.generateVideoSchemasFromResponse(this.ContentVideos)
      ],
      canonicalUrl: this.canonicalUrl
    })
  },
  async asyncData(ctx) {
    const { path: currentPath, fullPath } = ctx.route

    try {
      const canonicalUrl = generateCanonicalUrlForStaticPage(ctx, {
        staticPath: ROUTE.PRIVACY_POLICY
      })

      if (checkIfNonCanonicalPath(ctx, { currentPath, canonicalUrl })) {
        redirectHandler({ ctx, to: canonicalUrl })
        return
      }

      const dispatch = ctx.store.dispatch
      const applyFallback = ctx.app.$helper.applyFallback
      const responseData =
        (await dispatch('layouts/requestPrivacyNotice')) || MODEL

      return {
        canonicalUrl,
        ...applyFallback(
          {
            ...responseData,
            Content: getParsedHtmlWithReplacedMediaAttrs(responseData.Content, {
              images: responseData.ContentImages,
              videos: responseData.ContentVideos
            })
          },
          MODEL
        )
      }
    } catch (err) {
      ctx.app.$errorHandler(err, ctx)
    } finally {
      await ctx.store.dispatch('router/removeRouteFromQueue', fullPath)
    }
  },
  data() {
    return {
      canonicalUrl: this.$route.path,
      isInitialPageLoad: null
    }
  },
  methods: {
    processHtml
  }
}
</script>

<style lang="scss" scoped>
.terms-and-privacy {
  width: 100%;
  max-width: 850px;
  margin: 0 auto;

  .terms-and-privacy__title {
    margin-bottom: 30px;
  }

  .terms-and-privacy__content {
    margin-top: 10px;
  }
}
</style>
